import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  fetchInitializeAction,
  loadStateFieldsAction
} from "actions/workItemsActions";
import {
  selectDropDownStates,
  selectCurrentStateDetails,
  selectCurrentStateAbbr,
  selectCurrentStateName
} from "selector/initializeSelector";
import InfoPanel from "components/home/InfoPanel";

const mapStateToProps = state => {
  return {
    listItems: selectDropDownStates(state),
    stateDetails: selectCurrentStateDetails(state),
    disableStart: !selectCurrentStateAbbr(state),
    stateName: selectCurrentStateName(state)
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      fetchData: fetchInitializeAction,
      onSelection: loadStateFieldsAction
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoPanel);
